import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import StoreFinderApp from '@/storeFinder/StoreFinderApp';
import { loadCarousels } from '@/utils/Controllers/CarouselController';

document.addEventListener('DOMContentLoaded', () => {
  loadCarousels();
  // load specific namespace for store finder section
  i18n.loadNamespaces('storeFinder', () => {
    ReactDOM.render(
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <StoreFinderApp />
        </Suspense>
      </I18nextProvider>,
      document.getElementById('js-r-entry-store-finder'),
    );
  });
});
